import React from "react";
import {withRouter} from 'react-router-dom';

import axios from 'axios';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";

import Check from "@material-ui/icons/Check";
import Button from "components/CustomButtons/Button.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import CreditCardProcessorSignup from "../../views/Components/CreditCardProcessorSignup"

import AgreementUpload from "components/CustomUpload/AgreementUpload.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { SHOW_IN_SEARCH_NOTE, CREDIT_CARD_FEE_NOTE, API_ROOT, CREDIT_CARD_PROCESSOR } from 'api-config';
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { lineSplitToObject, getCreditCardFeeDisplay } from "../../assets/helpers/displayHelper";
import { convertToDisplayDate } from "../../assets/helpers/dataHelper";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle,
  ...regularFormsStyle
};

class PracticeSettings extends React.Component {
  constructor(props) {
    super(props);
    var providerId = false;
    var providerUuid = false;
    var showInSearch = false;
    var acceptCreditCards = false;
    var allowMonthlyPlans = false;
    var allowAnnualPlans = false;
    var includeUpdateButton = false;
    var getCurrentSettings = false;
    var showUpdatePatientAgreementButton = true;
    if (this.props.providerId) {
      providerId = this.props.providerId
    }
    if (this.props.providerUuid) {
      providerUuid = this.props.providerUuid
    }
    if (this.props.showInSearch) {
      showInSearch = this.props.showInSearch
    }
    if (this.props.acceptCreditCards) {
      acceptCreditCards = this.props.acceptCreditCards
    }
    if (this.props.allowMonthlyPlans) {
      allowMonthlyPlans = this.props.allowMonthlyPlans
    }
    if (this.props.allowAnnualPlans) {
      allowAnnualPlans = this.props.allowAnnualPlans
    }
    const chargeCreditCardFee = this.props.chargeCreditCardFee ? this.props.chargeCreditCardFee : false;
    if (this.props.includeUpdateButton) {
      includeUpdateButton = this.props.includeUpdateButton
    }
    if (this.props.getCurrentSettings) {
      getCurrentSettings = this.props.getCurrentSettings
    }
    if (typeof this.props.showUpdatePatientAgreementButton !== "undefined") {
      showUpdatePatientAgreementButton = this.props.showUpdatePatientAgreementButton
    }

    this.state = {
      providerId: providerId,
      providerUuid: providerUuid,
      showInSearch: showInSearch,
      acceptCreditCards: acceptCreditCards,
      allowMonthlyPlans: allowMonthlyPlans,
      allowAnnualPlans: allowAnnualPlans,
      chargeCreditCardFee: chargeCreditCardFee,
      creditCardFeeNote: '',
      includeUpdateButton: includeUpdateButton,
      getCurrentSettings: getCurrentSettings,
      organizationInfo: [],
      showCreditCardProcessingAccountSetup: false,
      showCreditCardProcessorNeededButton: false,
      showPatientAgreement: false,
      userAgreementText:  [{'line': 'loading...'}],
      userAgreementUpdateDate: '',
      showUpdatePatientAgreementButton: showUpdatePatientAgreementButton
    };
  }


  componentDidMount(){
    this._isMounted = true;
    if (this.state.getCurrentSettings) {
      this.getPracticeSettings();
    } else {
      this.getDefaultCreditCardFee();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleCheckboxToggle = event => {
    this.setState({
      [event.target.id]: event.target.checked
    })
    if (this.props.updateOption) {
      this.props.updateOption([event.target.id], event.target.checked)
    }
  }

  getPracticeSettings() {
    if (this.state.providerId) {
      axios.get(`${API_ROOT}/organizationInfo/?userId=` + this.state.providerId, { headers: getApiHeaders() })
        .then(res => this.setPracticeSettings({ responseMessage: res.data }));
    }
  }

  setPracticeSettings(res) {
    if (this._isMounted) {
      if (!res.responseMessage.error) {
        const creditCardFee = res.responseMessage.creditCardFee;
        if (creditCardFee) {
          this.setCreditCardFeeNote(creditCardFee)
        } else {
          this.getDefaultCreditCardFee()
        }
        this.setState({
          showInSearch: res.responseMessage.showInSearch,
          acceptCreditCards: res.responseMessage.acceptCreditCards,
          allowMonthlyPlans: res.responseMessage.allowMonthlyPlans,
          allowAnnualPlans: res.responseMessage.allowAnnualPlans,
          chargeCreditCardFee: res.responseMessage.chargeCreditCardFee,
          organizationInfo: res.responseMessage
        });
        if (res.responseMessage.acceptCreditCards) {
          this.getCreditCardProcessing()
        }
      }
    }
  }

  getCreditCardProcessing() {
    axios.get(`${API_ROOT}/connectedAccount/?userId=` + this.state.providerId + `&type=` + CREDIT_CARD_PROCESSOR, { headers: getApiHeaders() })
      .then(res => this.setCreditCardProcessing(res.data));
  }

  setCreditCardProcessing(res) {
    if (res.error && res.error === 'no account info') {
      this.setState({
        showCreditCardProcessorNeededButton: true
      })
    }
  }

  getPatientAgreement() {
    axios.get(`${API_ROOT}/userAgreement/?agreementType=memberAgreement&providerId=` + this.state.providerId, { headers: getApiHeaders() })
      .then(res => this.setPatientAgreement(res.data));
  }

  setPatientAgreement(res) {
    var agreementText =  [{'line': 'no agreement found'}]
    var activeStartDatetime = ''
    if (res[0].agreementText) {
      agreementText = lineSplitToObject(res[0].agreementText)
      activeStartDatetime = convertToDisplayDate(res[0].activeStartDatetime)
    }
    this.setState({
      userAgreementText: agreementText,
      userAgreementUpdateDate: activeStartDatetime
    })

  }
  updatePracticeSettings() {
    const orgData = {
      userId: this.state.providerId,
      taxId: this.state.organizationInfo.taxId,
      taxClassification: this.state.organizationInfo.taxClassification,
      showInSearch: this.state.showInSearch,
      acceptCreditCards: this.state.acceptCreditCards,
      allowMonthlyPlans: this.state.allowMonthlyPlans,
      allowAnnualPlans: this.state.allowAnnualPlans,
      chargeCreditCardFee: this.state.chargeCreditCardFee
    }
    axios.post(`${API_ROOT}/organizationInfo/`, orgData, { headers: getApiHeaders() })
      .then(res => this.handleUpdatePracticeSettings(res));
  }

  handleUpdatePracticeSettings(res) {
    const needCreditCardProcessingAccount = res.data.needCreditCardProcessingAccount
    if (needCreditCardProcessingAccount) {
      this.linkCreditCardProcessorOpen()
    }
  }

  linkCreditCardProcessorOpen() {
    this.setState({
      showCreditCardProcessingAccountSetup: true
    });
  }

  handleLinkCreditCardProcessorClose() {
    this.setState({
      showCreditCardProcessingAccountSetup: false
    });
  }

  handleShowPatientAgreementOpen() {
    this.getPatientAgreement()
    this.setState({
      showPatientAgreement: true
    });
  }

  handleShowPatientAgreementClose() {
    this.setState({
      showPatientAgreement: false
    });
  }

  getDefaultCreditCardFee() {
      axios.get(`${API_ROOT}/settings/?selectedSetting=jsonSettings&selectedJsonSetting=defaultCreditCardFee`, { headers: getApiHeaders() })
        .then(res => this.setDefaultCreditCardFee(res));
  }

  setDefaultCreditCardFee(res) {
    if (res.data && res.data.defaultCreditCardFee) {
      this.setCreditCardFeeNote(res.data.defaultCreditCardFee)
    }
  }


  setCreditCardFeeNote(creditCardFee) {
    const creditCardFeeNote = getCreditCardFeeDisplay(creditCardFee, 'provider')
    this.setState({
      creditCardFeeNote: creditCardFeeNote
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.state.showCreditCardProcessingAccountSetup}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='sm'
          width='sm'
        >
          <DialogTitle id="form-dialog-title">connect credit card account</DialogTitle>
          <DialogContent>
            <CreditCardProcessorSignup
              providerId = {this.state.providerId}
            />

          </DialogContent>

          <DialogActions>

            <Button onClick={this.handleLinkCreditCardProcessorClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showPatientAgreement}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='sm'
          width='sm'
        >
          <DialogTitle id="form-dialog-title">patient agreement</DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12}>
                Your patients sign the follow agreement:
              </GridItem>
              <GridItem xs={12} sm={12}>
                <div style={{height: 200, overflow: 'auto', margin: 20}}>
                  {this.state.userAgreementText.map((textOfLine, key) =>
                    <p style={{fontSize: textOfLine.fontSize, color: textOfLine.fontColor, fontWeight: textOfLine.fontWeight}} key={key}>{textOfLine.line}</p>
                  )}
                </div>
              </GridItem>
              <GridItem xs={12} sm={6}>
                last update: {this.state.userAgreementUpdateDate}
              </GridItem>
              <GridItem xs={12} sm={6}>
                <AgreementUpload
                  userId = {this.state.userId}
                  updateFunction = {this.getPatientAgreement.bind(this)}
                />
              </GridItem>



            </GridContainer>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleShowPatientAgreementClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={4}>
            <Checkbox
              id={'showInSearch'}
              onClick={this.handleCheckboxToggle}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
              checked={this.state.showInSearch}
            />show practice in search results
            <p></p>
          </GridItem>
          <GridItem xs={12} sm={8}>
            {SHOW_IN_SEARCH_NOTE}
          </GridItem>
          <GridItem xs={12} sm={4}>
            <Checkbox
              id={'acceptCreditCards'}
              onClick={this.handleCheckboxToggle}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
              checked={this.state.acceptCreditCards}
            />accept credit cards
            <Button
              color="cirrusBlue"
              onClick={this.linkCreditCardProcessorOpen.bind(this)}
              className={classes.updateProfileButton}
              type="submit"
              size='sm'
              style={this.state.showCreditCardProcessorNeededButton ? {} : { display: 'none' }}
            >
              set up processor
            </Button>
          </GridItem>
          <GridItem xs={12} sm={8}>
            {CREDIT_CARD_FEE_NOTE}
          </GridItem>
          <GridItem xs={12} sm={4} style={this.state.acceptCreditCards ? {} : { display: 'none' }}>
            <Checkbox
              id={'chargeCreditCardFee'}
              onClick={this.handleCheckboxToggle}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
              checked={this.state.chargeCreditCardFee}
            />add credit card surcharge
          </GridItem>
          <GridItem xs={12} sm={8} style={this.state.acceptCreditCards ? {} : { display: 'none' }}>
            {this.state.creditCardFeeNote}
          </GridItem>
          <GridItem xs={12} sm={4}>
            <Checkbox
              id={'allowMonthlyPlans'}
              onClick={this.handleCheckboxToggle}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
              checked={this.state.allowMonthlyPlans}
            />offer patients monthly plans
          </GridItem>
          <GridItem xs={12} sm={8}>
            {/*note here*/}
          </GridItem>

          <GridItem xs={12} sm={4}>
            <Checkbox
              id={'allowAnnualPlans'}
              onClick={this.handleCheckboxToggle}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot
              }}
              checked={this.state.allowAnnualPlans}
            />offer patients annual plans
          </GridItem>
          <GridItem xs={12} sm={8}>
            {/*note here*/}
          </GridItem>
          <GridItem xs={12} sm={12}>
            <Button
              color="cirrusBlue"
              onClick={this.updatePracticeSettings.bind(this)}
              className={classes.updateProfileButton}
              type="submit"
              style={this.state.includeUpdateButton ? {} : { display: 'none' }}
            >
              update
            </Button>
          </GridItem>

          <GridItem xs={12} sm={12} style={this.state.showUpdatePatientAgreementButton ? {} : { display: 'none' }}>
            <Button
              color="cirrusBlue"
              onClick={this.handleShowPatientAgreementOpen.bind(this)}
              className={classes.updateProfileButton}
              type="submit"
              size='sm'
            >
              view/update patient agreement
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withRouter(withStyles(style)(PracticeSettings));
